<template>
  <div v-loading="loading" class="main" id="titleTable">
    <div class="d1 lp">
      内容神器根据您当前文章内容，帮您推荐{{ getCount }}条标题
    </div>
    <div class="lp" v-for="(itme, index) in titles" :key="index">
      <div class="titleBox flex-box">
        <div style="flex: 1;padding: 10px 0;">
          {{ itme }}
        </div>
        <div>
          <button @click="use(itme)" class="btn">
            <i class="icons use"></i>使用
          </button>
        </div>
      </div>
    </div>
    <div style="text-align: center;margin: 0 auto;margin-top: 30px;">
      <button class="btn3" @click="getTitle" v-if="resetCheck">重新检测</button>
    </div>
  </div>
</template>

<script>
import { SendPostData } from "../../assets/script/model";
import tinymce from "tinymce";
import { mapActions } from "vuex";

export default {
  name: "GetTitle",
  data() {
    return {
      titles: [],
      getCount: 0,
      loading: false,
      resetCheck: false,
      showBoxType: false,
      typeName: ""
    };
  },
  mounted() {
    this.listenMessage();
    this.getid = setInterval(() => {
      let getBox = document.getElementById("titleTable");
      if (getBox) {
        clearInterval(this.getid);
        this.getHotLineHeight(this.contentHeight, "titleTable", -80);
        this.getTitle();
      }
    }, 500);
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    getTitles: {
      get() {
        return this.$store.state.wycContent.getTitle;
      },
      set(val) {
        this.$store.state.wycContent.getTitle = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    }
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "titleTable", -80);
      }
    }
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    listenMessage() {
      this.loading = true;
      let that = this;
      window.addEventListener("message", function(e) {
        if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
          if (!e.data.isclose && e.data.btn === "title") {
            that.getCount = e.data.data.length;
            let getMsg = e.data.data;
            if (getMsg) {
              that.resetCheck = true;
              that.loading = false;
              for (let item of getMsg) {
                that.titles.push(item.Data.tgt);
              }
            }
          }
          if (!e.data.isclose && e.data.btn === "aititle") {
            that.getCount += 1;
            let getMsg = e.data.data;
            if (getMsg) {
              that.loading = false;
              that.resetCheck = true;
              if (getMsg.ErrorCode > 0) {
                that.titles.push(getMsg.ErrorMess);
              } else {
                that.titles.push(getMsg.Data.tgt);
              }
            }
          }
        }
      });
    },
    async getTitle() {
      let result = await this.APermission({ SysName: "wycarticletitle" });
      if (result.errorCode > 0) {
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
        return;
      }
      if (result.data > 0 || result.data === -1) {
        this.titles = [];
        this.getCount = 0;
        if (this.wycShow) {
          let sendData = new SendPostData();
          sendData.btn = "title";
          this.SendMessage(sendData);
        } else {
          let content = tinymce.activeEditor.getBody().innerText + "\n";
          let content_list = content.split("\n");
          let sendData = new SendPostData();
          sendData.btn = "aititle";
          sendData.data = { txt: content, num: 0 };
          this.SendMessage(sendData);
          let num = 1;
          for (let item of content_list) {
            item = item.replace(/(^\s*)|(\s*$)/g, "");
            if (item !== "" && item.length > 30) {
              let sendData = new SendPostData();
              sendData.btn = "aititle";
              sendData.data = { txt: item, num: num };
              this.SendMessage(sendData);
              num++;
            }
            if (num > 5) {
              break;
            }
          }
        }
      } else {
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
        this.loading = false;
      }
    },
    use(title) {
      this.getTitles = title;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
* {
  font-size: 12px;
}
.main {
  height: 500px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
  .d1 {
    line-height: 30px;
  }
  .lp {
    padding: 0 18px;
  }
  .titleBox {
    background-color: @boxback-color;
    line-height: 25px;
    margin: 10px 5px 10px 0;
    padding-left: 10px;
  }
  .flex-box {
    .flex-box();
    text-align: left;
  }
  .btn {
    background-color: #fff;
    padding: 2px 8px;
    color: #6a6a6a;
    border: 1px solid #909c92;
    border-radius: 20px;
    cursor: pointer;
    margin-right: 8px;
    &:hover {
      background-color: #0f59f5;
      color: #fff;
      border: 1px solid #0f59f5;
      .use {
        background: url("../../assets/image/wyc/use_hover.png") no-repeat 50%;
        vertical-align: sub;
        margin-right: 3px;
      }
    }
  }
  .btn1 {
    background-color: #0f58f5;
    padding: 3px 9px;
    color: #fff;
    border: 1px solid #0f58f5;
    border-radius: 10px;
    cursor: pointer;
    margin-right: 8px;
  }
  .btn3 {
    .btn1;
    padding: 5px 15px;
    background-color: #167df3;
  }
  .icons {
    display: inline-block;
    height: 15px;
    width: 12px;
  }
  .use {
    background: url("../../assets/image/wyc/use_ico.png") no-repeat 50%;
    vertical-align: sub;
    margin-right: 3px;
  }
}
</style>
